import gql from "graphql-tag";

export const REGISTER_NEWSLETTER = gql`
  mutation RegisterNewsletter($input: NewsletterInput!) {
    registerNewsletter(input: $input)
  }
`;
